import { Component } from '@angular/core';

@Component({
  selector: 'app-arrow-left',
  imports: [],
  template: `<svg
  width="24"
  height="24"
  viewBox="0 0 22 22"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M9.93893 17.1672C10.0252 17.1676 10.1106 17.1508 10.1902 17.1178C10.2699 17.0847 10.3421 17.0361 10.4027 16.9747C10.5256 16.8517 10.5946 16.6849 10.5946 16.511C10.5946 16.3371 10.5256 16.1703 10.4027 16.0472L5.61643 11.261L10.4027 6.47472C10.5186 6.35032 10.5817 6.18578 10.5787 6.01577C10.5757 5.84575 10.5068 5.68354 10.3866 5.5633C10.2664 5.44307 10.1042 5.3742 9.93414 5.3712C9.76413 5.3682 9.59959 5.4313 9.47518 5.54722L4.22518 10.7972C4.10229 10.9203 4.03326 11.0871 4.03326 11.261C4.03326 11.4349 4.10229 11.6017 4.22518 11.7247L9.47518 16.9747C9.53577 17.0361 9.608 17.0847 9.68764 17.1178C9.76727 17.1508 9.85271 17.1676 9.93893 17.1672V17.1672Z"
    fill="white"
  />
  <path
    d="M4.68896 11.917H16.939C17.113 11.917 17.2799 11.8479 17.403 11.7248C17.5261 11.6017 17.5952 11.4348 17.5952 11.2607C17.5952 11.0867 17.5261 10.9198 17.403 10.7967C17.2799 10.6736 17.113 10.6045 16.939 10.6045H4.68896C4.51492 10.6045 4.348 10.6736 4.22493 10.7967C4.10185 10.9198 4.03271 11.0867 4.03271 11.2607C4.03271 11.4348 4.10185 11.6017 4.22493 11.7248C4.348 11.8479 4.51492 11.917 4.68896 11.917Z"
    fill="white"
  />
</svg>
`
})
export class ArrowLeftComponent {

}
